import React, { useEffect, useState } from "react";
import { Badge, Loader } from "@mantine/core";
import { useServerApi } from "../hooks/userServerApi";

const BankTransactionJournalBadge = ({ bankTransactionId, status }) => {
  const [api] = useServerApi();
  const [journalCode, setJournalCode] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!bankTransactionId || status !== "MATCHED") {
        setJournalCode(null);
        return;
      }
      setLoading(true);
      try {
        const data = await api.Accounting.getJournalsBySource(
          "bankTransaction",
          bankTransactionId
        );
        const entry = data?.journalEntries?.[0];
        setJournalCode(entry?.code || null);
      } finally {
        setLoading(false);
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankTransactionId, status]);

  if (status !== "MATCHED") return null;
  if (loading) return <Loader size="xs" />;
  if (!journalCode) return null;

  return (
    <Badge size="xs" color="blue" variant="light">
      JE: {journalCode}
    </Badge>
  );
};

export default BankTransactionJournalBadge;
